// extracted by mini-css-extract-plugin
module.exports = {"page":"page__3GOeS","body-wrapper":"body-wrapper__1MiZS","body":"body__2v5PQ","homework-submission-notice":"homework-submission-notice__UnPdq"};